import { render } from "./IncludeContextItem.vue?vue&type=template&id=6f327857"
import script from "./IncludeContextItem.vue?vue&type=script&lang=js"
export * from "./IncludeContextItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__